import { FC } from 'react';
import { Box, SxProps, Theme, Typography } from '@mui/material';
import { Colors } from '../../../constants'
import { LeaderboardStar } from '../../../icons';

interface PlaceholderProps {
	sx?: SxProps<Theme>;
}

export const Placeholder: FC<PlaceholderProps> = ({ sx }) => (
	<Box display="flex" flexDirection="column" gap="16px" sx={sx}>
		<Box display="flex" justifyContent="center">
			<Box
				component={LeaderboardStar}
				sx={{
					width: '32px',
					height: '32px',
					color: Colors.white,
				}}
			/>
		</Box>
		<Typography
			sx={{
				fontFamily: 'Montserrat, sans-serif',
				fontSize: '18px',
				fontWeight: 700,
				textAlign: 'center',
				color: Colors.white,
			}}
		>
			No leaderboard for now — stay tuned for updates!
		</Typography>
		<Typography
			sx={{
				fontFamily: 'Montserrat, sans-serif',
				fontSize: '15px',
				fontWeight: 500,
				lineHeight: '21px',
				textAlign: 'center',
				color: Colors.white,
			}}
		>
			No rankings have been recorded for this period yet.
		</Typography>
	</Box>
);
